export default __webpack_public_path__ + "static/media/coat.470f56d6.jpg";